import { ISiteUserInfo } from '../../../userManagement/users/models/ISiteUserInfo';
import React = require('react');
import { Formik, FormikProps } from 'formik';

import { FormikCheckbox } from '~commonInfra/components/FormikCheckbox';

import { Messages } from '../../../codegen/Localize';
import { UserSettingsStyle } from '../../styles/UserSettingsStyle';
import _ = require('underscore');
import { ToasterService, ToastType } from '~commonInfra/services/ToasterService';

import { IError } from '../../../httpClient/serverApi/types/IError';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { IServerUserInfo } from '../../../userManagement/users/models/IServerUserInfo';
import { UserSettings } from '../../services/resources/UserSettings';
import { InlineCancelAndSaveButtons } from '../UserSettingEditButtons';

export type DataOrientationProps = {
    userHasNoSiteId: boolean;
    siteUser: ISiteUserInfo;
    serverUser: IServerUserInfo;
}

export interface DataOrientationSuppressAutoOpenField {
    suppressAutoOpen: boolean;
}

export const DataOrientationSectionTestId: string = 'user-settings-data-orientation';
export const DataOrientationCheckBoxTestId: string = 'suppress-data-orientation-auto-open';

function showButtons(formik: FormikProps<DataOrientationSuppressAutoOpenField>, suppressAutoOpen: boolean) {
  if (!formik.touched || !formik.isValid || formik.isSubmitting || _.isEqual(formik.values.suppressAutoOpen, suppressAutoOpen)) {
    return false;
  }
  return true;
}

export function DataOrientationSettings(props: DataOrientationProps): JSX.Element {
  const [currentSuppressAutoOpen, setCurrentSuppressAutoOpen] = React.useState(false);

  function handleSubmit(values: DataOrientationSuppressAutoOpenField, siteUser: ISiteUserInfo) {
    UserSettings.updateShouldSuppressDataOrientationAutoOpen(
      siteUser.id, values.suppressAutoOpen
      ).then((result: IResult) => {
        setCurrentSuppressAutoOpen(values.suppressAutoOpen);
        ToasterService.instance.pop({ type: ToastType.Success, text: Messages.settingsUpdateSuccess() });
      }).catch((error: IError) => {
        ToasterService.instance.pop({ type: ToastType.Error, text: Messages.settingsUpdateFailure() });
      });
  }

  React.useEffect(
    () => {
      UserSettings.getShouldSuppressDataOrientationAutoOpen(props.serverUser.id)
      .then((result: boolean) => {
        setCurrentSuppressAutoOpen(result);
      }).catch((error: IError) => { });
    },
    [props.serverUser.id]
  );

  return (
    <Formik
      initialValues={{ suppressAutoOpen: currentSuppressAutoOpen }}
      onSubmit={(values: DataOrientationSuppressAutoOpenField) => handleSubmit(values, props.siteUser)}
      enableReinitialize={true}
    >
      {
        (formik: FormikProps<DataOrientationSuppressAutoOpenField>) => (
          <form onSubmit={formik.handleSubmit}>
            <table>
              <tbody className={UserSettingsStyle.tbody}>
                <tr data-tb-test-id={DataOrientationSectionTestId}>
                  <td className={UserSettingsStyle.labelText}>
                    {Messages.dataOrientationSettingSection()}</td>
                  <td className={UserSettingsStyle.detailsValue}>
                    {Messages.dataOrientationUserSettingDetail()}</td>
                </tr>
                <tr>
                  <td className={UserSettingsStyle.labelText}></td>
                  <td className={UserSettingsStyle.detailsValue}>
                    <FormikCheckbox
                      containerStyle={{marginLeft: 0}}
                      testId={DataOrientationCheckBoxTestId}
                      name='suppressAutoOpen'
                      disabled={props.userHasNoSiteId}
                      label={Messages.dataOrientationSuppressAutoOpen()}/>
                  </td>
                </tr>
                {
                  showButtons(formik, currentSuppressAutoOpen) &&
                  <InlineCancelAndSaveButtons
                    testId='data-orientation'
                    formik={formik}
                  />
                }
               </tbody>
            </table>
          </form>
        )
      }
    </Formik>
  );

}